<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          @click="openDetailDialog(scope.row)"
        >详情
        </el-button>
<!--        <el-button
          type="text"
          size="small"
          @click="openReportDialog(scope.row)"
          v-if="scope.row.taskStatus === 2"
        >报告
        </el-button>-->
      </template>
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-if="projectFlag"
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>
    <el-dialog
      title="详情"
      :visible.sync="detailFlag"
      :modal-append-to-body="false"
      width="70%"
      @close="closeDetailDialog"
      append-to-body
    >
<!--      <el-row>-->
<!--        <el-button-->
<!--          type="success"-->
<!--          icon="el-icon-switch-button"-->
<!--          style="float: right;margin:5px"-->
<!--          size="small"-->
<!--          v-show="finishBtnFlag"-->
<!--          @click="finishTask"-->
<!--        >完 成-->
<!--        </el-button>-->

<!--        <el-button-->
<!--          type="primary"-->
<!--          icon="el-icon-video-play"-->
<!--          style="float: right;margin:5px"-->
<!--          size="small"-->
<!--          v-show="startBtnFlag"-->
<!--          @click="startTask"-->
<!--        >开 始-->
<!--        </el-button>-->
<!--      </el-row>-->
      <avue-form
        ref="editForm"
        v-model="form"
        :option="detailOption"
        label-width="150px"
        margin-top="0"
      >
        <template slot-scope="scope" slot="taskLists">
          <avue-crud :option="listOption"
                     :table-loading="loading"
                     :data="deviceMaintenanceList"
                     @row-update="taskListUpdate"
          >
          </avue-crud>
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog
      title="报告"
      :visible.sync="reportFlag"
      :modal-append-to-body="false"
      width="70%"
      @close="closeReportDialog"
      append-to-body
    >
      <avue-form
        ref="editForm"
        v-model="form"
        :option="reportOption"
        label-width="150px"
        margin-top="0"
      >
        <template slot-scope="scope" slot="taskLists">
          <avue-crud
            :option="reportListOption"
            :table-loading="loading"
            :data="listData"
            v-model="taskListForm"
          >
          </avue-crud>
        </template>
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update, getReport} from "@/api/crmedical/upkeep/upkeeptask";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";

  export default {
    data() {
      return {
        taskListForm: {},
        reportFlag: false,
        detailFlag: false,
        startBtnFlag: false,
        finishBtnFlag: false,
        projectFlag: true,
        projectList: [],
        form: {},
        query: {
          taskStatus:'',
          projectId:'',
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        listOption:{
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          indexLabel:'序号',
          columnBtn: false,
          align:'center',
          refreshBtn: false,
          cellBtn: false,
          menu: false,
          column: [
            {
              label: "合同编号",
              prop: "contractCode",
            },
            {
              label: "合同名称",
              prop: "contractName",
            },
            {
              label: "维保单位",
              prop: "signDept",
            },
            {
              label: "设备名称",
              prop: "deviceName",
            },
            {
              label: "设备编号",
              prop: "deviceCode",
            },
            {
              label: "存放位置",
              prop: "areaName",
            },
            {
              label: "所属部门",
              prop: "deviceDeptName",
            },
            {
              label: "维保内容",
              prop: "content",
              overHidden: true,
            },
            {
              label: "维保状态",
              prop: "isUpkeep",
              type: 'radio',
              cell: true,
              dicData: [
                {
                  label: '是',
                  value: 1,
                },
                {
                  label: '否',
                  value: 0,
                },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: "维保时间",
              prop: "upkeepTime",
              type:'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            {
              label: "备注",
              prop: "remark",
            },
          ],
          //2021年5月17日14:58:36 替换成上面的
          columnOld: [
            {
              label: "维保类型",
              prop: "projectType",
              type: 'select',
              dicUrl: 'api/blade-system/dict/dictionary?code=upkeep_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'string',
            },
            {
              label: "名称",
              prop: "mainName",
            },
            {
              label: "维保内容",
              prop: "content",
              overHidden: true,
            },
            {
              label: "是否维保",
              prop: "isUpkeep",
              type: 'radio',
              cell: true,
              dicData: [
                {
                  label: '是',
                  value: 1,
                },
                {
                  label: '否',
                  value: 0,
                },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: "维保时间",
              prop: "upkeepTime",
              type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
            },
            {
              label: "备注",
              prop: "remark",
              overHidden: true,
              maxlength: 200,
              showWordLimit: true,
              span: 24,
              type: 'textarea',
            },
            {
              label: '图片',
              prop: 'imgStr',
              type: 'upload',
              span: 24,
              propsHttp: {
                res: 'data',
                url: 'link',
                name: 'originalName',
              },
              dataType: 'string',
            },
          ],
        },
        detailOption:{
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          column: [
            {
              label: "项目名称",
              prop: "projectName",
              placeholder: ' ',
              disabled: true,
              span: 8,
            },
            {
              label: "计划名称",
              prop: "planName",
              placeholder: ' ',
              disabled: true,
              span: 8,
            },
            {
              label: "任务名称",
              prop: "name",
              disabled: true,
              span: 8,
            },
            {
              label: "维保负责人",
              prop: "chargeManName",
              placeholder: ' ',
              disabled: true,
              span: 8,
            },
            // {
            //   label: "维保班组",
            //   prop: "groupName",
            //   disabled: true,
            // },
            {
              label: "任务开始时间",
              prop: "taskStartTime",
              disabled: true,
              span: 8,
            },
            {
              label: "任务结束时间",
              prop: "taskEndTime",
              disabled: true,
              span: 8,
            },
            {
              label: "任务明细",
              prop: "taskLists",
              disabled: true,
              formslot: true,
              span: 24
            }
          ]
        },
        option: {
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          indexLabel:'序号',
          columnBtn: false,
          searchMenuSpan: 6,
          menuWidth: 100,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              span: 6,
            },
            {
              label: "项目名称",
              prop: "project",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              search: true,
              searchslot:true,
              hide: true,
              display: false,
              span: 12,
            },
            {
              label: "任务名称",
              prop: "name",
              width: 300,
            },
            // {
            //   label: "维保班组",
            //   prop: "groupId",
            //   search: true,
            //   hide: true,
            // },
            // {
            //   label: "维保班组",
            //   prop: "groupName",
            // },
            {
              label: "任务开始时间",
              prop: "taskStartTime",
            },
            {
              label: "任务结束时间",
              prop: "taskEndTime",
            },
            {
              label: '维保单位',
              prop: 'signDept',
            },
            {
              label: "任务状态",
              prop: "taskStatus",
              display: false,
              type: 'select',
              dicUrl: 'api/blade-system/dict/dictionary?code=task_status',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'string',
              search: true,
            },
          ]
        },
        reportOption:{
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          column: [
            {
              label: "项目名称",
              prop: "projectName",
              disabled: true,
              span: 8,
            },
            {
              label: "计划名称",
              prop: "groupName",
              disabled: true,
              span: 8,
            },
            {
              label: "维保班组",
              prop: "groupName",
              disabled: true,
              span: 8,
            },
            {
              label: "完成时间",
              prop: "endTime",
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              disabled: true,
              span: 8,
            },
            {
              label: "维保单位",
              prop: "signDept",
              disabled: true,
              span: 8,
            },
            {
              label: "任务明细",
              prop: "taskLists",
              disabled: true,
              formslot: true,
              span: 24
            }
          ]
        },
        reportListOption:{
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          indexLabel:'序号',
          columnBtn: false,
          align:'center',
          refreshBtn: false,
          cellBtn: false,
          menu: false,
          column: [
            {
              label: "维保类型",
              prop: "projectType",
              type: 'select',
              dicUrl: 'api/blade-system/dict/dictionary?code=upkeep_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'string',
            },
            {
              label: "名称",
              prop: "mainName",
            },
            {
              label: "维保内容",
              prop: "content",
              overHidden: true,
            },
            {
              label: "是否维保",
              prop: "isUpkeep",
              type: 'radio',
              cell: true,
              dicData: [
                {
                  label: '是',
                  value: 1,
                },
                {
                  label: '否',
                  value: 0,
                },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: "维保时间",
              prop: "upkeepTime",
              type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
            },
            {
              label: "维保人",
              prop: "realUpkeepMan",
            },
            {
              label: "备注",
              prop: "remark",
              overHidden: true,
              maxlength: 200,
              showWordLimit: true,
              span: 24,
              type: 'textarea',
            },
          ],
        },
        data: [],
        listData : [],
        deviceMaintenanceList:[],
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.upkeeptask_add, false),
          viewBtn: this.vaildData(this.permission.upkeeptask_view, false),
          delBtn: this.vaildData(this.permission.upkeeptask_delete, false),
          editBtn: this.vaildData(this.permission.upkeeptask_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      openReportDialog(row){
        getReport({id: row.id}).then(({data})=>{
          this.form = data;
          this.listData = data.taskLists;
          this.reportFlag = true;
        })
      },
      closeReportDialog(){
        this.reportFlag = false;
        this.form = {};
        this.listData = {};
      },
      projectChange(value){
        this.projectFlag = false;
        this.query.projectId = value;
        this.query.project = value;
        setTimeout(()=>{
          this.projectFlag = true;
        },10)
      },
      finishTask(){
        var b = false;
        for (let i = 0; i < this.listData.length; i++) {
          if(this.listData[i].isUpkeep === 0){
            b = true;
            this.$message.error('第'+ (i+1) + '项维保内容未维保');
            break;
          }
        }
        if(b){
          return;
        }
        update({id: this.form.id,taskStatus: 2,taskLists: this.listData}).then(()=>{
          this.openDetailDialog(this.form);
          this.$message.success('操作成功!');
        }, error => {
          console.log(error);
        });
      },
      startTask(){
        update({id: this.form.id,taskStatus:1}).then(()=>{
          this.openDetailDialog(this.form);
          this.$message.success('操作成功!');
        }, error => {
          console.log(error);
        });
      },
      openDetailDialog(row){
        getDetail({id: row.id}).then(({data}) => {
          this.form = data;
          if(this.form.taskStatus === 0){
            this.listOption.cellBtn = false;
            this.startBtnFlag = true;
          }else if(this.form.taskStatus === 1){
            this.listOption.cellBtn = true;
            this.startBtnFlag = false;
            this.finishBtnFlag = true;
          }else if(this.form.taskStatus === 2){
            this.listOption.cellBtn = false;
            this.startBtnFlag = false;
            this.finishBtnFlag = false;
          }
          this.listData = data.taskLists;
          this.deviceMaintenanceList = data.deviceMaintenanceList;
          this.detailFlag = true;
        });
      },
      closeDetailDialog(){
        this.detailFlag = false;
        this.onLoad();
      },
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      taskListUpdate(row, index, loading, done) {
        loading();
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query.taskStatus = '';
        this.onLoad();
      },
      searchChange(params,done) {
        // this.query = params;
        console.log(params);
        this.query.taskStatus = params.taskStatus;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          console.log(this.query);
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          });
        }else {
          getProjectList().then((data)=>{
            this.projectList = data.data;
            if(this.projectList.length > 0){
              this.query.projectId = this.projectList[0].id;
              this.query.project = this.projectList[0].name;
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            }
          });
        }
      }
    }
  };
</script>

<style>
</style>
